import React from "react";
//#region types
import { MonthlySalaryInputProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { InputField } from "components/common";
import { useDebouncedCallback } from "use-debounce";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const MonthlySalaryInput: React.FC<MonthlySalaryInputProps> = (props) => {
  const { amount, currency, onChange } = props;

  const [internalValue, setInternalValue] = React.useState<number | undefined>(amount);

  const debouncedHandleOnChange = useDebouncedCallback((value?: number) => {
    onChange(value);
  }, 700);

  const handleOnChangeCustom = React.useCallback((value: number) => {
    setInternalValue(value ?? undefined);
    debouncedHandleOnChange(value ?? undefined);
  }, []);

  return (
    <InputField
      label=" "
      inputBaseProps={{
        value: internalValue,
        error: internalValue === undefined || Number(internalValue) < 0,
      }}
      isNumericString
      decimalPoints={2}
      allowNegative={false}
      suffix={LocalizationHelperInstance.getCurrencySymbol(currency)}
      onChangeCustom={handleOnChangeCustom}
    />
  );
};

export default MonthlySalaryInput;
